import { Skeleton } from "@/components/ui/skeleton";

export const VehicleCardSkeleton = () => (
  <div className="card-clean p-0 overflow-hidden">
    <Skeleton className="w-full aspect-[16/10]" />
    <div className="p-5">
      <Skeleton className="h-3 w-16 mb-2" />
      <Skeleton className="h-5 w-2/3" />
      <div className="mt-3 flex gap-2">
        <Skeleton className="h-6 w-12" />
        <Skeleton className="h-6 w-16" />
        <Skeleton className="h-6 w-14" />
      </div>
      <div className="mt-4 flex items-center justify-between">
        <Skeleton className="h-8 w-20" />
        <Skeleton className="h-10 w-24" />
      </div>
    </div>
  </div>
);
